import React from 'react';
import './Chapters.scss';

function Chapter1() {
  return (
    <section className="chapter">
      <p className="chapter__paragraph">
        It’s 8:00 a.m. at the{' '}
        <a
          href="https://fareshare.org.uk/"
          target="_blank"
          rel="sponsored"
          className="chapter__paragraph__link"
        >
          FareShare
        </a>{' '}
        headquarters in Manchester, UK, when the first donations of the day start rolling in on
        “juggernauts”—large, heavy trucks filled with an assortment of surplus food. Some trucks
        come right from manufacturers with canned or packaged goods. Others come from distribution
        centers with fresh produce that didn’t sell as quickly as merchandisers had expected.
      </p>
    </section>
  );
}

export default Chapter1;
